import store from "../../store/store";

export const componentKey = "SETTINGS_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setDrugList: (state, action) => {
      state.drugList = action.payload;
    },
    setCloseAddDrugDialog: (state, action) => {
      state.closeAddDrugDialog = action.payload;
    },
    setCodeList: (state, action) => {
      state.codeList = action.payload;
    },
    appendCodeList: (state, action) => {
      const next = action.payload;
      state.codeList = {
        ...next,
        data: {
          ...next?.data,
          codes: [
            ...(state.codeList?.data?.codes ?? []),
            ...(next?.data?.codes ?? []),
          ],
        },
      };
    },
    setCloseAddCodeDialog: (state, action) => {
      state.closeAddCodeDialog = action.payload;
    },
    setTemplateList: (state, action) => {
      state.templateList = action.payload;
    },
    setTemplateNameOptions: (state, action) => {
      state.templateNameOptions = action.payload;
    },
    setCloseAddTemplateDialog: (state, action) => {
      state.closeAddTemplateDialog = action.payload;
    },
    setCloseAddUserDialog: (state, action) => {
      state.closeAddUserDialog = action.payload;
    },
    setAdminUsersList: (state, action) => {
      state.adminUserList = action.payload;
    },
    getDataImport: (state, action) => {
      state.dataImportList = action.payload;
    },
    setCloseDataImportData: (state, action) => {
      state.closeDataImportDialog = action.payload;
    },
    setRolesResponsibilityList: (state, action) => {
      state.rolesResponsibilityList = action.payload;
    },
    setCloseAddRolesResponsibilityDialog: (state, action) => {
      state.closeAddRolesResponsibilityDialog = action.payload;
    },
    getAdminUserProfileData: (state, action) => {
      state.adminUserProfileData = action.payload;
    },
    setCloseAdminUserProfileData: (state, action) => {
      state.closeAdminUserProfile = action.payload;
    },
    setCommunicationRulesList: (state, action) => {
      state.communicationRulesList = action.payload;
    },
    setCommunicationRuleById: (state, action) => {
      state.communicationRuleById = action.payload;
    },
    setCloseAddCommunicationRuleDialog: (state, action) => {
      state.closeAddCommunicationRuleDialog = action.payload;
    },
    setOrderStatusList: (state, action) => {
      state.orderStatusList = action.payload;
    },
    setCloseAddOrderStatusDialog: (state, action) => {
      state.closeAddOrderStatusDialog = action.payload;
    },
    setTemplateImportResults: (state, action) => {
      state.templateImportResults = action.payload;
    },
    setOpenTemplateImportResultsDialog: (state, action) => {
      state.openTemplateImportResultsDialog = action.payload;
    },
    setMasterRoleCreated: (state, action) => {
      state.masterRoleCreated = action.payload;
    },
    setMasterRoleList: (state, action) => {
      state.masterRoleList = action.payload;
    },
    setCloseMasterRoleDialog: (state, action) => {
      state.closeMasterRoleDialog = action.payload;
    },
    setMasterDataList: (state, action) => {
      state.masterDataList = action.payload;
    },
    setCloseMasterDataDialog: (state, action) => {
      state.closeMasterDataDialog = action.payload;
    },
    setOrderTypeList: (state, action) => {
      state.orderTypeList = action.payload;
    },
    setCloseAddOrderTypeDialog: (state, action) => {
      state.closeAddOrderTypeDialog = action.payload;
    },
  },
  initialReducerState: {
    drugList: {},
    closeAddDrugDialog: false,
    codeList: {},
    closeAddCodeDialog: false,
    templateList: {},
    templateNameOptions: [],
    closeAddTemplateDialog: false,
    closeAddUserDialog: false,
    adminUserList: {},
    dataImportList: {},
    closeDataImportDialog: false,
    rolesResponsibilityList: {},
    closeAddRolesResponsibilityDialog: false,
    adminUserProfileData: {},
    closeAdminUserProfile: false,
    communicationRulesList: {},
    communicationRuleById: {},
    closeAddCommunicationRuleDialog: false,
    orderStatusList: {},
    closeAddOrderStatusDialog: false,
    templateImportResults: null,
    openTemplateImportResultsDialog: false,
    masterRoleCreated: null,
    masterRoleList: {},
    closeMasterRoleDialog: false,
    masterDataList: {},
    closeMasterDataDialog: false,
    orderTypeList: {},
    closeAddOrderTypeDialog: false,
  },
});

export const {
  setDrugList,
  setCloseAddDrugDialog,
  setCodeList,
  appendCodeList,
  setCloseAddCodeDialog,
  setTemplateList,
  setTemplateNameOptions,
  setCloseAddTemplateDialog,
  setCloseAddUserDialog,
  setAdminUsersList,
  getDataImport,
  setCloseDataImportData,
  setRolesResponsibilityList,
  setCloseAddRolesResponsibilityDialog,
  getAdminUserProfileData,
  setCloseAdminUserProfileData,
  setCommunicationRulesList,
  setCommunicationRuleById,
  setCloseAddCommunicationRuleDialog,
  setOrderStatusList,
  setCloseAddOrderStatusDialog,
  setTemplateImportResults,
  setOpenTemplateImportResultsDialog,
  setMasterRoleCreated,
  setMasterRoleList,
  setCloseMasterRoleDialog,
  setMasterDataList,
  setCloseMasterDataDialog,
  setOrderTypeList,
  setCloseAddOrderTypeDialog,
} = actions;
